module.exports = "img/taller-ab-1.bed897.jpg";